/* Physical crop of generated filled M/L/Q/Z artwork. No mask/clipPath is
 * required by the exported SVG. Original artwork remains immutable.
 * Quadratic intersections are solved analytically; surviving curves retain
 * their geometry. Compound paths keep even/odd holes, including edge holes.
 * Filled engraving only: boundary bridges are not intended as laser routes.
 * Photo-product default is the exact physical face, without a safety inset.
 *
 * [Réserves — expert-suite, 31/10/2026] options.reserves : les boîtes des textes, motifs, logos et QR posés
 * sur la photo. Elles sont retirées EXACTEMENT du dessin avant la découpe à la face, qui reste la dernière
 * étape (la photo peut déborder de la pièce : rien n'est gravé hors de la face). Sans réserve, crop() est
 * l'ancienne fonction (cropNu), au caractère près.
 *
 * [réserve-courbe — 02/11/2026] Une réserve peut aussi porter une FORME (mot courbé : un secteur d'anneau ; mot ou motif
 * pivoté : un rectangle de biais), découpée en pièces convexes par le bloc FORME-RESERVE ci-dessous : la terre nue suit le mot,
 * plus d'escalier. Réglages v2 (mêmes nombres que v1). Une liste de seules boîtes donne les octets d'avant.
 */
(function(root){'use strict';
/* ==== FORME-RESERVE v1 : copie conforme de reserve-courbe/commun/forme-reserve.js — ne pas retoucher ici ==== */
/* La réserve qui suit le mot (02/11/2026, demande de Benjamin : « une courbe quand le texte est courbé, ou un rectangle de biais
   quand le texte est sur le côté », sur les quatre souvenirs). Le moteur (mtFondBoites) pose sur la boîte d'un mot courbé ou pivoté
   une FORME, celle de l'encre, sans marge, en mm du repère du fond, angles en degrés (y vers le bas : horaire à l'écran) :
     {k:'rect', cx, cy, w, h, a}             rectangle w × h centré en (cx, cy), tourné de a ;
     {k:'arc',  ox, oy, r0, r1, a0, a1}      secteur d'anneau de centre O, rayons r0 < r1, de l'angle a0 à a1.
   Ce bloc la change en PIÈCES CONVEXES pour une marge et un rayon de coin donnés : union Clipper (carte, ciel), soustraction de
   PhotoCrop (qui ne retire que des convexes), exclusions de l'onde, étiquette peinte au glisser. Deux pièces d'un même mot ne
   partagent jamais un sommet, un bord ni un alignement (grille alternée, bouts au quart de pas) : le test exact de PhotoCrop
   (croiserAretes, 1e-7 mm) ne les trouve jamais dégénérées. ES5 pur, sans dépendance : collé tel quel dans le moteur, les bundles
   carte et ciel, leurs workers, l'IIFE de PhotoCrop et le rendu de l'onde. Référence : reserve-courbe/conception (§ 2, 4). */
var MTFormeReserve = (function () {
  'use strict';
  var D2R = Math.PI / 180, RIN_MIN = 1, FLECHE_INT = 0.15, KMAX = 17;
  function fini(v) { return typeof v === 'number' && isFinite(v); }
  /** Une forme lisible : genre connu, nombres finis ; rect w, h > 0 ; arc 0 ≤ r0 < r1 ≤ 5000, a0 dans ]−180, 180], ouverture
      dans ]0, 300[. Sinon la boîte sert, comme avant. */
  function valide(f) {
    if (!f || typeof f !== 'object') return false;
    if (f.k === 'rect') return fini(f.cx) && fini(f.cy) && fini(f.w) && fini(f.h) && fini(f.a) && f.w > 0 && f.h > 0;
    if (f.k === 'arc') return fini(f.ox) && fini(f.oy) && fini(f.r0) && fini(f.r1) && fini(f.a0) && fini(f.a1) &&
      f.r0 >= 0 && f.r0 < f.r1 && f.r1 <= 5000 && f.a0 > -180 && f.a0 <= 180 && f.a1 - f.a0 > 0 && f.a1 - f.a0 < 300;
    return false;
  }
  /* pas angulaire d'un arc de rayon r pour une flèche fl (r = 3, fl = 0,01 : 10 segments par quart, comme rectArrondi) */
  function pasArc(r, fl) { return 2 * Math.acos(Math.max(-1, 1 - fl / r)); }
  /* enveloppe convexe (chaîne monotone d'Andrew), colinéaires retirés, rendue en sens positif (lacet > 0, y vers le bas) */
  function cr(o, a, b) { return (a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0]); }
  function enveloppe(P) {
    var Q = P.slice().sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; }), lo = [], hi = [], i, p;
    for (i = 0; i < Q.length; i++) { p = Q[i]; while (lo.length >= 2 && cr(lo[lo.length - 2], lo[lo.length - 1], p) <= 1e-12) lo.pop(); lo.push(p); }
    for (i = Q.length - 1; i >= 0; i--) { p = Q[i]; while (hi.length >= 2 && cr(hi[hi.length - 2], hi[hi.length - 1], p) <= 1e-12) hi.pop(); hi.push(p); }
    var h = lo.slice(0, -1).concat(hi.slice(0, -1)), a = 0;
    for (i = 0; i < h.length; i++) { var u = h[i], v = h[(i + 1) % h.length]; a += u[0] * v[1] - v[0] * u[1]; }
    return a < 0 ? h.reverse() : h;
  }
  /* un convexe arrondi de r : à chaque sommet, l'arc de centre V entre les normales extérieures des deux bords (sommets sur l'arc) ;
     sommets confondus retirés ; un seul sommet → un cercle ; r = 0 → tel quel */
  function nor(A, B) { var dx = B[0] - A[0], dy = B[1] - A[1], l = Math.hypot(dx, dy); return Math.atan2(-dx / l, dy / l); }
  function arrondir(P, r, fl) {
    var Q = P.filter(function (q, i) { return !i || Math.hypot(q[0] - P[i - 1][0], q[1] - P[i - 1][1]) > 1e-9; }), out = [], n, i, j, k;
    if (Q.length > 1 && Math.hypot(Q[0][0] - Q[Q.length - 1][0], Q[0][1] - Q[Q.length - 1][1]) <= 1e-9) Q.pop();
    if (!(r > 0)) return Q;
    if (Q.length === 1) {
      n = Math.max(8, Math.ceil(2 * Math.PI / pasArc(r, fl)));
      for (k = 0; k < n; k++) out.push([Q[0][0] + r * Math.cos(2 * Math.PI * k / n), Q[0][1] + r * Math.sin(2 * Math.PI * k / n)]);
      return out;
    }
    n = Q.length;
    for (i = 0; i < n; i++) {
      var A = Q[(i + n - 1) % n], V = Q[i], B = Q[(i + 1) % n], t0 = nor(A, V), da = nor(V, B) - t0;
      while (da < 0) da += 2 * Math.PI; while (da >= 2 * Math.PI) da -= 2 * Math.PI;
      k = Math.max(1, Math.ceil(da / pasArc(r, fl) - 1e-9));
      for (j = 0; j <= k; j++) { var t = t0 + da * j / k; out.push([V[0] + r * Math.cos(t), V[1] + r * Math.sin(t)]); }
    }
    return out.filter(function (q, i) { return !i || Math.hypot(q[0] - out[i - 1][0], q[1] - out[i - 1][1]) > 1e-9; });
  }
  /** Les pièces convexes (sens positif) de la réserve « encre ⊖ (rE − marge) ⊕ disque(rE) » : [[[x, y], …], …], ou [] pour une
      forme illisible. rect : UNE pièce, exactement rectArrondi(boîte ± marge, rayon) tourné. arc : une pièce (l'enveloppe du ruban)
      quand une tranche suffit ou que l'intérieur est serré (Rin < 1 mm) ; sinon K tranches impaires sur une grille alternée (entière
      / demi-pas, ≥ 2 pas chacune) et deux bouts posés au quart de pas, sans leurs points sur le ruban. La corde intérieure d'une
      tranche mord de 0,15 mm au plus vers le centre (plus de terre nue, jamais moins). */
  function pieces(f, marge, rayon, fleche) {
    if (!valide(f) || !fini(marge) || !fini(rayon)) return [];
    var fl = fini(fleche) && fleche > 0 ? fleche : 0.01, rE, e, a, ca, sa, hx, hy, i, k;
    if (f.k === 'rect') {
      rE = Math.max(0, Math.min(rayon, f.w / 2 + marge, f.h / 2 + marge)); e = Math.max(0, rE - marge);
      hx = Math.max(0, f.w / 2 - e); hy = Math.max(0, f.h / 2 - e); a = f.a * D2R; ca = Math.cos(a); sa = Math.sin(a);
      return [arrondir([[-hx, -hy], [hx, -hy], [hx, hy], [-hx, hy]].map(function (q) { return [f.cx + q[0] * ca - q[1] * sa, f.cy + q[0] * sa + q[1] * ca]; }), rE, fl)];
    }
    var sp0 = (f.a1 - f.a0) * D2R, rm = (f.r0 + f.r1) / 2;
    rE = Math.max(0, Math.min(rayon, (f.r1 - f.r0) / 2 + marge, sp0 * rm / 2 + marge)); e = Math.max(0, rE - marge);
    var R0 = f.r0 > 0 ? f.r0 + e : 0, R1 = Math.max(R0, f.r1 - e), dl = R1 > 0 ? Math.asin(Math.min(1, e / R1)) : 0;
    var b0 = f.a0 * D2R + dl, b1 = f.a1 * D2R - dl; if (b1 < b0) b0 = b1 = (b0 + b1) / 2;
    var sp = b1 - b0, Rin = R0 - rE, Rout = R1 + rE;
    var po = function (r, t) { return [f.ox + r * Math.cos(t), f.oy + r * Math.sin(t)]; };
    var N = sp > 0 ? Math.max(1, Math.ceil(sp / pasArc(Rout, fl) - 1e-9)) : 0, dA = N ? sp / N : 0;   // LA grille extérieure : b0 + i·dA
    /* les deux quarts de cercle d'un bout (sg = −1 au début, +1 à la fin : τ vers l'extérieur) ; coupé : sans son point sur le
       cercle extérieur (j = 0 du premier quart) ni sur l'intérieur (j = nq du second), sommets de la tranche voisine */
    var nq = Math.max(1, Math.ceil((Math.PI / 2) / pasArc(rE, fl) - 1e-9));
    var bout = function (b, sg, coupe) {
      var ux = Math.cos(b), uy = Math.sin(b), tx = -uy * sg, ty = ux * sg, C1 = [f.ox + R1 * ux, f.oy + R1 * uy], C0 = [f.ox + R0 * ux, f.oy + R0 * uy], P = [], j, t;
      for (j = coupe ? 1 : 0; j <= nq; j++) { t = (Math.PI / 2) * j / nq; P.push([C1[0] + rE * (ux * Math.cos(t) + tx * Math.sin(t)), C1[1] + rE * (uy * Math.cos(t) + ty * Math.sin(t))]); }
      for (j = 0; j <= (coupe ? nq - 1 : nq); j++) { t = (Math.PI / 2) * j / nq; P.push([C0[0] + rE * (tx * Math.cos(t) - ux * Math.sin(t)), C0[1] + rE * (ty * Math.cos(t) - uy * Math.sin(t))]); }
      return P;
    };
    /* nombre de tranches : impair, ≥ 2 pas chacune (k et k + 2 ne se touchent jamais), au plus 17 */
    var K = 1;
    if (Rin >= RIN_MIN && N >= 3) {
      var spanMax = Rin > FLECHE_INT ? pasArc(Rin, FLECHE_INT) : Math.PI;
      var m = Math.max(2, Math.floor(spanMax / dA) - 1), kmax = Math.min(KMAX, Math.floor(N / 2));
      K = Math.min(Math.ceil(N / m), kmax);
      if (K % 2 === 0) K = K + 1 <= kmax ? K + 1 : K - 1;
    }
    var P;
    if (K <= 1) {                     // UNE pièce : l'enveloppe du ruban entier (arc extérieur, quatre quarts de cercle)
      P = []; for (i = 0; i <= N; i++) P.push(po(Rout, b0 + i * dA));
      return [enveloppe(P.concat(bout(b0, -1, false), bout(b1, 1, false)))];
    }
    var out = [], c = [];
    for (k = 0; k <= K; k++) c.push(Math.round(k * N / K));
    for (k = 0; k < K; k++) {         // tranche paire : la grille entière ; impaire : la demi-grille, un demi-pas sur chaque voisine
      var h = k % 2 ? 0.5 : 0, i0 = c[k] - h, i1 = c[k + 1] + h;
      P = []; for (i = i0; i <= i1 + 1e-9; i += 1) P.push(po(Rout, b0 + i * dA));
      P.push(po(Rin, b0 + i1 * dA), po(Rin, b0 + i0 * dA));
      out.push(P);
    }
    /* les bouts : leur côté droit à un quart de pas DANS la première / dernière tranche (aucune grille n'y passe) */
    out.push(enveloppe([po(Rin, b0 + dA / 4), po(Rout, b0 + dA / 4)].concat(bout(b0, -1, true))));
    out.push(enveloppe([po(Rin, b1 - dA / 4), po(Rout, b1 - dA / 4)].concat(bout(b1, 1, true))));
    return out;
  }
  /** [x0, y0, x1, y1] des sommets d'une liste de pièces (null si vide). */
  function boite(pc) {
    var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity, i, j;
    for (i = 0; i < (pc || []).length; i++) for (j = 0; j < pc[i].length; j++) {
      var q = pc[i][j]; if (q[0] < x0) x0 = q[0]; if (q[1] < y0) y0 = q[1]; if (q[0] > x1) x1 = q[0]; if (q[1] > y1) y1 = q[1];
    }
    return x0 <= x1 ? [x0, y0, x1, y1] : null;
  }
  /** {x, y, w, h} exacte de l'encre (la forme sans marge) : rect, ses 4 coins ; arc, ses 4 coins, le cercle extérieur à chaque
      multiple de 90° de [a0, a1], et O quand r0 = 0. Null pour une forme illisible. */
  function boiteEncre(f) {
    if (!valide(f)) return null;
    var P = [], a, ca, sa, k;
    if (f.k === 'rect') {
      a = f.a * D2R; ca = Math.cos(a); sa = Math.sin(a);
      [[-1, -1], [1, -1], [1, 1], [-1, 1]].forEach(function (s) { var u = s[0] * f.w / 2, v = s[1] * f.h / 2; P.push([f.cx + u * ca - v * sa, f.cy + u * sa + v * ca]); });
    } else {
      [f.r0, f.r1].forEach(function (r) { [f.a0, f.a1].forEach(function (t) { P.push([f.ox + r * Math.cos(t * D2R), f.oy + r * Math.sin(t * D2R)]); }); });
      for (k = Math.ceil(f.a0 / 90); k * 90 <= f.a1; k++) P.push([f.ox + f.r1 * Math.cos(k * Math.PI / 2), f.oy + f.r1 * Math.sin(k * Math.PI / 2)]);
      if (f.r0 === 0) P.push([f.ox, f.oy]);
    }
    var b = boite([P]);
    return { x: b[0], y: b[1], w: b[2] - b[0], h: b[3] - b[1] };
  }
  /** « Collé au bas » (carte, ciel) : la pièce convexe qui prolonge des pièces proches du bas jusqu'à bas + 3·rayon (les coins
      arrondis du bas sortent de la pièce, comme q[3] = bas + 3·RAYON d'une boîte), ou null si elles sont à colle mm du bas ou plus. */
  function jupe(pc, bas, colle, rayon) {
    var b = boite(pc), S = [], i, j;
    if (!b || bas - b[3] >= colle) return null;
    for (i = 0; i < pc.length; i++) for (j = 0; j < pc[i].length; j++) if (pc[i][j][1] >= b[3] - 2 * rayon) S.push(pc[i][j]);
    var n = S.length; for (i = 0; i < n; i++) S.push([S[i][0], bas + 3 * rayon]);
    return enveloppe(S);
  }
  /** Le texte d'une forme (marque de la photo, signatures) : 'r:cx,cy,w,h,a' ou 'a:ox,oy,r0,r1,a0,a1', nombres par String() (déjà
      arrondis par le moteur) ; '' pour une forme illisible. lire(s) en est l'inverse (null si illisible). */
  function champs(f) { return f.k === 'rect' ? [f.cx, f.cy, f.w, f.h, f.a] : [f.ox, f.oy, f.r0, f.r1, f.a0, f.a1]; }
  function texte(f) { return valide(f) ? (f.k === 'rect' ? 'r:' : 'a:') + champs(f).map(String).join(',') : ''; }
  function lire(s) {
    var m = typeof s === 'string' ? /^([ra]):([^:]*)$/.exec(s) : null;
    if (!m) return null;
    var v = m[2].split(','), f, i;
    if (v.length !== (m[1] === 'r' ? 5 : 6)) return null;
    for (i = 0; i < v.length; i++) { if (!/\S/.test(v[i])) return null; v[i] = Number(v[i]); }
    f = m[1] === 'r' ? { k: 'rect', cx: v[0], cy: v[1], w: v[2], h: v[3], a: v[4] } : { k: 'arc', ox: v[0], oy: v[1], r0: v[2], r1: v[3], a0: v[4], a1: v[5] };
    return valide(f) ? f : null;
  }
  return { V: 1, valide: valide, pieces: pieces, boite: boite, boiteEncre: boiteEncre, jupe: jupe, texte: texte, lire: lire };
})();
/* ==== FIN FORME-RESERVE v1 ==== */
 const EPS=1e-8;let lastSvg=null,lastParsed=null;
 const near=(a,b)=>Math.hypot(a.x-b.x,a.y-b.y)<EPS;
 const point=(x,y)=>({x,y});
 function surface(shape,options={}){
  const square=shape==='carree',width=square?130:120,height=square?130:100,margin=Number(options.margin??0);
  if(!Number.isFinite(margin)||margin<0||margin>=Math.min(width,height)/2)throw Error('Marge de gravure invalide.');
  const outer=square?[[0,0],[width,0],[width,height],[0,height]]:[[width/4,0],[3*width/4,0],[width,height/2],[3*width/4,height],[width/4,height],[0,height/2]];
  const planes=outer.map((p,i)=>{const q=outer[(i+1)%outer.length],dx=q[0]-p[0],dy=q[1]-p[1],length=Math.hypot(dx,dy),a=-dy/length,b=dx/length;return {a,b,c:-a*p[0]-b*p[1]-margin};});
  const polygon=planes.map((q,i)=>{const p=planes[(i+planes.length-1)%planes.length],det=p.a*q.b-q.a*p.b;return [(p.b*q.c-q.b*p.c)/det,(q.a*p.c-p.a*q.c)/det];});
  return {width,height,margin,polygon,planes};
 }
 function parse(svg){
  if(svg===lastSvg)return lastParsed;
  if(typeof svg!=='string'||svg.length>2000000)throw Error('Dessin SVG non pris en charge.');
  if(/\btransform\s*=|<(?!\/?(?:svg|path)\b)[A-Za-z]/i.test(svg))throw Error('Le recadrage attend les contours du dessin original.');
  const box=/\bviewBox\s*=\s*["']([^"']+)["']/i.exec(svg),view=box?box[1].trim().split(/[\s,]+/).map(Number):[];
  if(view.length!==4||!view.every(Number.isFinite)||view[2]<=0||view[3]<=0)throw Error('Dimensions du dessin SVG invalides.');
  const groups=[];
  for(const tag of svg.matchAll(/<path\b[^>]*>/gi)){
   const attr=/\bd\s*=\s*(["'])(.*?)\1/s.exec(tag[0]);if(!attr)continue;
   const d=attr[2],re=/[MLQZ]|[-+]?(?:\d*\.\d+|\d+\.?\d*)(?:[eE][-+]?\d+)?/g,tokens=d.match(re)||[];
   if(d.replace(re,'').replace(/[\s,]/g,''))throw Error('Ce dessin utilise un type de courbe non pris en charge.');
   let i=0,cmd='',start=null,current=null,segments=[],contours=[];
   function number(){const t=tokens[i++],v=Number(t);if(t===undefined||/[MLQZ]/.test(t)||!Number.isFinite(v))throw Error('Contour SVG incomplet.');return v;}
   function finish(){if(!start)return;if(segments.length&&!near(current,start))segments.push({type:'L',p0:current,p2:start});if(segments.length)contours.push(segments);segments=[];start=null;current=null;}
   while(i<tokens.length){
    if(/^[MLQZ]$/.test(tokens[i]))cmd=tokens[i++];
    if(cmd==='M'){finish();current=start=point(number(),number());cmd='L';}
    else if(cmd==='L'){if(!current)throw Error('Contour SVG sans départ.');const end=point(number(),number());segments.push({type:'L',p0:current,p2:end});current=end;}
    else if(cmd==='Q'){if(!current)throw Error('Contour SVG sans départ.');const control=point(number(),number()),end=point(number(),number());segments.push({type:'Q',p0:current,p1:control,p2:end});current=end;}
    else if(cmd==='Z'){finish();cmd='';}
    else throw Error('Contour SVG incomplet.');
   }
   finish();if(contours.length)groups.push(contours);
  }
  const parsed={view,groups};lastSvg=svg;lastParsed=parsed;return parsed;
 }
 function evaluate(s,t){const u=1-t;return s.type==='L'?point(u*s.p0.x+t*s.p2.x,u*s.p0.y+t*s.p2.y):point(u*u*s.p0.x+2*u*t*s.p1.x+t*t*s.p2.x,u*u*s.p0.y+2*u*t*s.p1.y+t*t*s.p2.y);}
 function interval(s,t0,t1){
  if(t0===0&&t1===1)return s;
  const p0=evaluate(s,t0),p2=evaluate(s,t1);if(s.type==='L')return {type:'L',p0,p2};
  const dt=t1-t0,p1=point(p0.x+dt*((1-t0)*(s.p1.x-s.p0.x)+t0*(s.p2.x-s.p1.x)),p0.y+dt*((1-t0)*(s.p1.y-s.p0.y)+t0*(s.p2.y-s.p1.y)));
  return {type:'Q',p0,p1,p2};
 }
 const distance=(plane,p)=>plane.a*p.x+plane.b*p.y+plane.c;
 function intersections(s,plane){
  const f0=distance(plane,s.p0),f2=distance(plane,s.p2),f1=s.type==='Q'?distance(plane,s.p1):(f0+f2)/2,a=f0-2*f1+f2,b=2*(f1-f0),c=f0;
  let roots=[];
  if(Math.abs(a)<1e-12){if(Math.abs(b)>1e-12)roots=[-c/b];}
  else{let disc=b*b-4*a*c;const tol=1e-12*(b*b+Math.abs(4*a*c)+1);if(disc>=-tol){disc=Math.sqrt(Math.max(0,disc));const q=-.5*(b+(b<0?-disc:disc));roots=Math.abs(q)<1e-15?[-b/(2*a)]:[q/a,c/q];}}
  return roots.filter(t=>Number.isFinite(t)&&t>1e-10&&t<1-1e-10).sort((x,y)=>x-y).filter((t,i,a)=>!i||t-a[i-1]>1e-10);
 }
 function cut(contour,plane,state){
  const pieces=[];
  for(const s of contour){const stops=[0,...intersections(s,plane),1];for(let i=1;i<stops.length;i++){
   const a=stops[i-1],b=stops[i];if(distance(plane,evaluate(s,(a+b)/2))>=-EPS)pieces.push(interval(s,a,b));else state.clipped=true;
  }}
  if(!pieces.length)return [];
  const joined=[];let previous=pieces[pieces.length-1].p2;
  for(const s of pieces){if(!near(previous,s.p0))joined.push({type:'L',p0:previous,p2:s.p0});joined.push(s);previous=s.p2;}
  return joined;
 }
 function extrema(s){
  const pts=[s.p0,s.p2];if(s.type==='Q')for(const axis of ['x','y']){const denominator=s.p0[axis]-2*s.p1[axis]+s.p2[axis];if(Math.abs(denominator)>1e-12){const t=(s.p0[axis]-s.p1[axis])/denominator;if(t>0&&t<1)pts.push(evaluate(s,t));}}return pts;
 }
 function signedArea(contour){
  const cross=(a,b)=>a.x*b.y-a.y*b.x;let twiceArea=0;
  for(const s of contour){if(s.type==='L')twiceArea+=cross(s.p0,s.p2);else{const b=point(2*(s.p1.x-s.p0.x),2*(s.p1.y-s.p0.y)),c=point(s.p0.x-2*s.p1.x+s.p2.x,s.p0.y-2*s.p1.y+s.p2.y);twiceArea+=cross(s.p0,b)+cross(s.p0,c)+cross(b,c)/3;}}
  return twiceArea/2;
 }
 function cropNu(svg,element,shape,options={}){
  const parsed=parse(svg),area=surface(shape,options),{width:W,height:H}=area,view=parsed.view;
  const size=Number(element.size),x=Number(element.x),y=Number(element.y);
  if(![size,x,y].every(Number.isFinite)||size<=0)throw Error('Position du dessin invalide.');
  const scale=size*1.2/Math.max(view[2],view[3]),cx=view[0]+view[2]/2,cy=view[1]+view[3]/2;
  const transform=p=>point((p.x-cx)*scale+x*W,(p.y-cy)*scale+y*H),state={clipped:false},groups=[];let paths=0,points=0,minX=Infinity,minY=Infinity,maxX=-Infinity,maxY=-Infinity;
  const n=v=>String(Math.round(v*1e4)/1e4),coord=p=>n(p.x)+' '+n(p.y);
  for(const group of parsed.groups){let d='';for(const contour of group){
   let result=contour.map(s=>({type:s.type,p0:transform(s.p0),...(s.p1?{p1:transform(s.p1)}:{}),p2:transform(s.p2)}));
   for(const plane of area.planes){result=cut(result,plane,state);if(!result.length)break;}
   if(!result.length)continue;
   let loX=Infinity,hiX=-Infinity,loY=Infinity,hiY=-Infinity;for(const s of result)for(const p of extrema(s)){loX=Math.min(loX,p.x);hiX=Math.max(hiX,p.x);loY=Math.min(loY,p.y);hiY=Math.max(hiY,p.y);}
   // Contacts with an edge or a single vertex have no engravable area.
   if(hiX-loX<EPS||hiY-loY<EPS||Math.abs(signedArea(result))<1e-10)continue;
   paths++;points+=result.length;minX=Math.min(minX,loX);minY=Math.min(minY,loY);maxX=Math.max(maxX,hiX);maxY=Math.max(maxY,hiY);
   d+='M'+coord(result[0].p0);for(const s of result)d+=s.type+(s.type==='Q'?coord(s.p1)+' ':'')+coord(s.p2);d+='Z';
  }if(d)groups.push('<path d="'+d+'"/>');}
  const output='<svg xmlns="http://www.w3.org/2000/svg" width="'+W+'mm" height="'+H+'mm" viewBox="0 0 '+W+' '+H+'" fill="#4a2616" fill-rule="evenodd" stroke="none">'+groups.join('')+'</svg>';
  return {svg:output,viewBox:[0,0,W,H],placement:{x:.5,y:.5,size:Math.max(W,H)/1.2},physical:{width:W,height:H},polygon:area.polygon,paths,points,bounds:paths?{minX,minY,maxX,maxY}:null,clipped:state.clipped};
 }
 /* ── RÉSERVES (expert-suite, 31/10/2026) ─────────────────────────────────────────────────
  * options.reserves = les boîtes des textes et motifs posés sur la photo, {x,y,w,h} en mm de la pièce
  * (celles de mtFondBoites, arrondies au centième). Chaque boîte, élargie de `marge` et arrondie de
  * `rayon`, devient un polygone convexe U_j. On retire EXACTEMENT leur union U du dessin rempli D
  * (pair/impair) AVANT la découpe à la face, qui reste la découpe d'origine :
  *   · les bords de D sont coupés là où ils croisent ∂U (racines analytiques, comme `intersections`) ;
  *   · on garde les morceaux de ∂D hors de U, et les morceaux de ∂U dans D (parité tenue le long de ∂U :
  *     un seul lancer de rayon par polygone, puis on bascule à chaque croisement) ;
  *   · chaque nœud a alors exactement deux morceaux : on les enchaîne en boucles fermées. Le bord de
  *     D − U est parcouru une fois et une seule : aucun recouvrement, aucune couture, trous gardés.
  * Un cas dégénéré (sommet du dessin sur un bord de réserve, tangence, bords alignés) relance le calcul
  * avec les réserves élargies de quelques cent-millièmes de mm : déterministe, invisible.
  * Seules les réserves qui RETIRENT de l'encre sont gardées (sortie `reserves`) : une boîte posée hors du
  * dessin ne change rien, pas même la marque. Sans réserve utile : la découpe d'origine, à l'octet. */
 /* Les réglages portent un NOM de version, écrit dans la marque de la photo (data-mtp-reserves="v1;…") : une marque se
    redécoupe toujours avec SES réglages, même si l'on change la marge un jour. v1 = ceux de la carte et du ciel (Benjamin,
    31/10) : 2 mm autour de la boîte, coins de 3 mm ; flèche des arcs 0,01 mm ; poussières de moins de 0,15 mm² retirées. */
 const RESERVE=Object.freeze({marge:2,rayon:3,fleche:0.01,ilot:0.15});
 /* [réserve-courbe, 02/11] v2 = les mêmes nombres, et des formes dans la marque (data-mtp-reserves="v2;…;a:…") */
 const VERSIONS=Object.freeze({v1:RESERVE,v2:Object.freeze({...RESERVE,formes:true})});
 const TOL_D=1e-7,TOL_U=1e-9,DEGENERE={degenere:true};
 const r2=v=>Math.round(v*100)/100;
 const chevauche=(a,b)=>a[0]<=b[2]&&b[0]<=a[2]&&a[1]<=b[3]&&b[1]<=a[3];
 /* Les boîtes, au centième, dans un ordre canonique, sans doublon (la marque ne dépend ni de l'ordre des
    éléments ni d'un texte posé deux fois au même endroit).
    [réserve-courbe, 02/11] Une entrée qui porte une forme lisible la garde, relue depuis son texte (les nombres mêmes de la marque),
    avec sa boîte au centième : les boîtes d'abord (l'ordre d'avant), puis les formes dans l'ordre de leur texte, chacune une fois.
    Une forme illisible : la boîte, comme avant. */
 function boitesValides(liste){
  const vues=new Set(),out=[],formes=[];
  for(const b of Array.isArray(liste)?liste:[]){
   if(!b)continue;
   const f=b.forme?MTFormeReserve.lire(MTFormeReserve.texte(b.forme)):null;
   if(f){const t=MTFormeReserve.texte(f);if(vues.has(t))continue;let q=[+b.x,+b.y,+b.w,+b.h].map(r2);
    if(!(q.every(Number.isFinite)&&q[2]>0&&q[3]>0)){const e=MTFormeReserve.boiteEncre(f);q=[e.x,e.y,e.w,e.h].map(r2);}   // (une marque relue sans sa boîte)
    vues.add(t);formes.push({t,b:{x:q[0],y:q[1],w:q[2],h:q[3],forme:f}});continue;}
   const x=r2(+b.x),y=r2(+b.y),w=r2(+b.w),h=r2(+b.h);
   if(![x,y,w,h].every(Number.isFinite)||w<=0||h<=0)continue;
   const k=x+','+y+','+w+','+h;if(vues.has(k))continue;vues.add(k);out.push({x,y,w,h});
  }
  out.sort((a,b)=>a.x-b.x||a.y-b.y||a.w-b.w||a.h-b.h);
  return formes.length?out.concat(formes.sort((a,b)=>a.t<b.t?-1:a.t>b.t?1:0).map(q=>q.b)):out;
 }
 /* Le rectangle arrondi d'une boîte, en polygone convexe (sommets SUR les arcs, flèche ≤ `fleche`). */
 function polygoneReserve(b,o=RESERVE,delta=0){
  const m=(o.marge??RESERVE.marge)+delta,X0=b.x-m,Y0=b.y-m,X1=b.x+b.w+m,Y1=b.y+b.h+m;
  const r=Math.max(0,Math.min(o.rayon??RESERVE.rayon,(X1-X0)/2,(Y1-Y0)/2)),fl=o.fleche??RESERVE.fleche;
  const n=r>fl?Math.max(1,Math.ceil(Math.PI/2/(2*Math.acos(Math.max(-1,1-fl/r))))):0,pts=[];
  const coin=(cx,cy,a0)=>{for(let k=0;k<=n;k++){const a=a0+k*Math.PI/2/n;pts.push(point(cx+r*Math.cos(a),cy+r*Math.sin(a)));}};
  if(n){coin(X1-r,Y0+r,-Math.PI/2);coin(X1-r,Y1-r,0);coin(X0+r,Y1-r,Math.PI/2);coin(X0+r,Y0+r,Math.PI);}
  else pts.push(point(X1,Y0),point(X1,Y1),point(X0,Y1),point(X0,Y0));
  const p=pts.filter((q,i)=>!i||Math.hypot(q.x-pts[i-1].x,q.y-pts[i-1].y)>1e-9);
  if(Math.hypot(p[0].x-p[p.length-1].x,p[0].y-p[p.length-1].y)<=1e-9)p.pop();
  return p;
 }
 /* [réserve-courbe, 02/11] Les pièces convexes d'une réserve, marge grossie de `delta` : une boîte → son rectangle arrondi (inchangé) ;
    une forme → les pièces du bloc (une pour un rectangle de biais, une ou plusieurs tranches qui se croisent franchement pour un
    arc), en points. L'écran, le masque du geste et la découpe les retirent toutes, dans un même chemin. */
 function piecesReserve(b,o=RESERVE,delta=0){
  if(!b||!b.forme||!MTFormeReserve.valide(b.forme))return [polygoneReserve(b,o,delta)];
  return MTFormeReserve.pieces(b.forme,(o.marge??RESERVE.marge)+delta,o.rayon??RESERVE.rayon,o.fleche??RESERVE.fleche).map(p=>p.map(v=>point(v[0],v[1])));
 }
 /* aux essais, une pièce d'une forme grandit à sa façon (son plus loin sommet de `dep`, autour de la moyenne de ses sommets, qui
    est dedans : elle reste convexe) : deux pièces d'un même mot ne gardent jamais un bord sur la même droite */
 function homothetie(p,dep){let mx=0,my=0;for(const v of p){mx+=v.x;my+=v.y;}mx/=p.length;my/=p.length;let rr=0;for(const v of p)rr=Math.max(rr,Math.hypot(v.x-mx,v.y-my));const l=1+dep/Math.max(rr,1e-6);return p.map(v=>point(mx+(v.x-mx)*l,my+(v.y-my)*l));}
 /* La réserve, ramenée à la face (deux convexes : Sutherland–Hodgman sur ses sommets). Ce qui déborde de la
    pièce ne compte pas : une réserve « utile » est une réserve qui retire de l'encre SUR la pièce. La face est
    élargie de `ecart` (quelques cent-millièmes de mm, propres à chaque réserve) : deux réserves coupées au même
    bord de la pièce n'ont jamais de bords confondus. */
 function couperPoly(pts,planes,ecart=0){
  for(const p0 of planes){
   const pl={a:p0.a,b:p0.b,c:p0.c+ecart};
   const out=[];
   for(let i=0;i<pts.length;i++){const A=pts[i],B=pts[(i+1)%pts.length],dA=distance(pl,A),dB=distance(pl,B);if(dA>=0)out.push(A);if((dA>=0)!==(dB>=0)){const t=dA/(dA-dB);out.push(point(A.x+t*(B.x-A.x),A.y+t*(B.y-A.y)));}}
   pts=out.filter((q,i)=>!i||Math.hypot(q.x-out[i-1].x,q.y-out[i-1].y)>1e-9);
   if(pts.length>1&&Math.hypot(pts[0].x-pts[pts.length-1].x,pts[0].y-pts[pts.length-1].y)<=1e-9)pts.pop();
   if(pts.length<3)return null;
  }
  let s=0;for(let i=0;i<pts.length;i++){const a=pts[i],b=pts[(i+1)%pts.length];s+=a.x*b.y-b.x*a.y;}
  return Math.abs(s)/2>1e-6?pts:null;
 }
 function preparerPolygone(pts){
  let s=0;for(let i=0;i<pts.length;i++){const a=pts[i],b=pts[(i+1)%pts.length];s+=a.x*b.y-b.x*a.y;}
  const o=s>0?1:-1,edges=[];let box=[Infinity,Infinity,-Infinity,-Infinity];
  for(let k=0;k<pts.length;k++){
   const A=pts[k],B=pts[(k+1)%pts.length],dx=B.x-A.x,dy=B.y-A.y,len2=dx*dx+dy*dy,len=Math.sqrt(len2);
   edges.push({A,B,dx,dy,len2,a:-o*dy/len,b:o*dx/len,c:o*(dy*A.x-dx*A.y)/len,box:[Math.min(A.x,B.x)-TOL_D,Math.min(A.y,B.y)-TOL_D,Math.max(A.x,B.x)+TOL_D,Math.max(A.y,B.y)+TOL_D]});
   box=[Math.min(box[0],A.x),Math.min(box[1],A.y),Math.max(box[2],A.x),Math.max(box[3],A.y)];
  }
  return {pts,edges,box};
 }
 /* Strictement dedans (un point du bord n'arrive jamais ici : les cas limites sont relancés). */
 function dedans(P,p){if(p.x<P.box[0]||p.x>P.box[2]||p.y<P.box[1]||p.y>P.box[3])return false;for(const e of P.edges)if(e.a*p.x+e.b*p.y+e.c<=0)return false;return true;}
 function boiteSeg(s){const xs=[s.p0.x,s.p2.x],ys=[s.p0.y,s.p2.y];if(s.p1){xs.push(s.p1.x);ys.push(s.p1.y);}return [Math.min(...xs),Math.min(...ys),Math.max(...xs),Math.max(...ys)];}
 function boiteSegs(c){let b=[Infinity,Infinity,-Infinity,-Infinity];for(const s of c){const q=boiteSeg(s);b=[Math.min(b[0],q[0]),Math.min(b[1],q[1]),Math.max(b[2],q[2]),Math.max(b[3],q[3])];}return b;}
 /* Un segment du dessin contre un bord de réserve : racines t ∈ ]0,1[, et u sur le bord. */
 function croiserSegArete(s,e,out){
  const f0=e.a*s.p0.x+e.b*s.p0.y+e.c,f2=e.a*s.p2.x+e.b*s.p2.y+e.c,f1=s.type==='Q'?e.a*s.p1.x+e.b*s.p1.y+e.c:(f0+f2)/2;
  if((f0>TOL_D&&f1>TOL_D&&f2>TOL_D)||(f0<-TOL_D&&f1<-TOL_D&&f2<-TOL_D))return;
  const u=p=>((p.x-e.A.x)*e.dx+(p.y-e.A.y)*e.dy)/e.len2,surArete=v=>v>-TOL_U&&v<1+TOL_U;
  if(Math.abs(f0)<TOL_D&&surArete(u(s.p0)))throw DEGENERE;
  if(Math.abs(f2)<TOL_D&&surArete(u(s.p2)))throw DEGENERE;
  const a=f0-2*f1+f2,b=2*(f1-f0),c=f0;let roots=[];
  if(s.type==='Q'&&Math.abs(a)>1e-15){const tm=-b/(2*a);if(tm>0&&tm<1&&Math.abs(c-b*b/(4*a))<TOL_D&&surArete(u(evaluate(s,tm))))throw DEGENERE;}
  if(Math.abs(a)<1e-12){if(Math.abs(b)>1e-12)roots=[-c/b];}
  else{const disc=b*b-4*a*c;if(disc>0){const sq=Math.sqrt(disc),q=-.5*(b+(b<0?-sq:sq));roots=q?[q/a,c/q]:[];}}
  for(const t of roots){
   if(!(t>0&&t<1))continue;const P=evaluate(s,t),v=u(P);
   if(v<=-TOL_U||v>=1+TOL_U)continue;if(v<TOL_U||v>1-TOL_U)throw DEGENERE;
   out.push({t,u:v,x:P.x,y:P.y});
  }
 }
 /* Deux bords de réserves (l'union) : croisement franc seulement. */
 function croiserAretes(e,g,out){
  const d1=g.a*e.A.x+g.b*e.A.y+g.c,d2=g.a*e.B.x+g.b*e.B.y+g.c,d3=e.a*g.A.x+e.b*g.A.y+e.c,d4=e.a*g.B.x+e.b*g.B.y+e.c;
  if((d1>TOL_D&&d2>TOL_D)||(d1<-TOL_D&&d2<-TOL_D)||(d3>TOL_D&&d4>TOL_D)||(d3<-TOL_D&&d4<-TOL_D))return;
  if(Math.abs(d1)<TOL_D||Math.abs(d2)<TOL_D||Math.abs(d3)<TOL_D||Math.abs(d4)<TOL_D)throw DEGENERE;
  const t=d1/(d1-d2),P=point(e.A.x+t*e.dx,e.A.y+t*e.dy);
  out.push({ue:t,ug:((P.x-g.A.x)*g.dx+(P.y-g.A.y)*g.dy)/g.len2,x:P.x,y:P.y});
 }
 /* Lancer de rayon vers +x : nombre de croisements d'un segment (règle demi-ouverte, quadratiques coupées
    à leur extremum en y). La parité de la somme dit si le point est dans le dessin (pair/impair). */
 function croisementsRayon(s,P){
  if(s.type==='L'){const a=s.p0,b=s.p2;if((a.y>P.y)!==(b.y>P.y)&&a.x+(P.y-a.y)*(b.x-a.x)/(b.y-a.y)>P.x)return 1;return 0;}
  const y0=s.p0.y,y1=s.p1.y,y2=s.p2.y,A=y0-2*y1+y2,B=2*(y1-y0),Cc=y0-P.y;let bornes=[0,1],n=0;
  if(Math.abs(A)>1e-15){const te=(y0-y1)/A;if(te>0&&te<1)bornes=[0,te,1];}
  for(let k=1;k<bornes.length;k++){
   const ta=bornes[k-1],tb=bornes[k],ya=evaluate(s,ta).y,yb=evaluate(s,tb).y;
   if((ya>P.y)===(yb>P.y))continue;
   let t;if(Math.abs(A)<1e-15)t=-Cc/B;else{const sq=Math.sqrt(Math.max(0,B*B-4*A*Cc)),q=-.5*(B+(B<0?-sq:sq)),r=[q/A,q?Cc/q:NaN];t=r.find(v=>v>=ta-1e-9&&v<=tb+1e-9);if(t===undefined)t=(ta+tb)/2;}
   if(evaluate(s,Math.min(tb,Math.max(ta,t))).x>P.x)n++;
  }
  return n;
 }
 function parite(P,contours,boites){let n=0;for(let i=0;i<contours.length;i++){const b=boites[i];if(P.y<b[1]||P.y>b[3]||P.x>b[2])continue;for(const s of contours[i])n+=croisementsRayon(s,P);}return n&1;}
 const renverser=segs=>segs.slice().reverse().map(s=>s.type==='Q'?{type:'Q',p0:s.p2,p1:s.p1,p2:s.p0}:{type:'L',p0:s.p2,p2:s.p0});
 const milieu=s=>evaluate(s,.5);
 /* D − U pour UN groupe (un <path>, pair/impair). polys : [{j, P}] (ceux qui touchent la boîte du groupe). */
 function soustraire(contours,polys,utiles,pariteD){
  const n=contours.length,bx=contours.map(boiteSegs),surSeg=contours.map(c=>new Array(c.length).fill(null)),touche=new Array(n).fill(false);
  const surArete=polys.map(({P})=>P.edges.map(()=>[]));
  for(let i=0;i<n;i++)for(let jj=0;jj<polys.length;jj++){
   const {j,P}=polys[jj];if(!chevauche(bx[i],P.box))continue;
   const c=contours[i];
   for(let q=0;q<c.length;q++){
    const sb=boiteSeg(c[q]);if(!chevauche(sb,P.box))continue;
    for(let k=0;k<P.edges.length;k++){
     const e=P.edges[k];if(!chevauche(sb,e.box))continue;
     const h=[];croiserSegArete(c[q],e,h);
     for(const x of h){const nd={x:x.x,y:x.y,D:true};(surSeg[i][q]||(surSeg[i][q]=[])).push({t:x.t,nd});surArete[jj][k].push({u:x.u,nd});touche[i]=true;utiles.add(j);}
    }
   }
  }
  for(let a=0;a<polys.length;a++)for(let b=a+1;b<polys.length;b++){
   const Pa=polys[a].P,Pb=polys[b].P;if(!chevauche(Pa.box,Pb.box))continue;
   for(let ka=0;ka<Pa.edges.length;ka++)for(let kb=0;kb<Pb.edges.length;kb++){
    if(!chevauche(Pa.edges[ka].box,Pb.edges[kb].box))continue;
    const h=[];croiserAretes(Pa.edges[ka],Pb.edges[kb],h);
    for(const x of h){const nd={x:x.x,y:x.y,D:false};surArete[a][ka].push({u:x.ue,nd});surArete[b][kb].push({u:x.ug,nd});}
   }
  }
  const autreDedans=(a,p)=>polys.some((x,b)=>b!==a&&dedans(x.P,p)),dansU=p=>polys.some(x=>dedans(x.P,p));
  const sortie=[],runs=[];
  /* les contours du dessin */
  for(let i=0;i<n;i++){
   const c=contours[i];
   if(!touche[i]){
    const p=c[0].p0,jj=polys.findIndex(x=>dedans(x.P,p));
    if(jj<0)sortie.push({segs:c,touche:false});else utiles.add(polys[jj].j);
    continue;
   }
   const pieces=[];
   for(let q=0;q<c.length;q++){
    const s=c[q],l=surSeg[i][q];
    if(!l){pieces.push({s,n0:null,n1:null});continue;}
    l.sort((x,y)=>x.t-y.t);
    for(let k=1;k<l.length;k++)if(l[k].t-l[k-1].t<1e-12)throw DEGENERE;
    let t0=0,n0=null;
    for(const x of l){const sub=interval(s,t0,x.t);pieces.push({s:{...sub,p0:n0?point(n0.x,n0.y):sub.p0,p2:point(x.nd.x,x.nd.y)},n0,n1:x.nd});t0=x.t;n0=x.nd;}
    const fin=interval(s,t0,1);pieces.push({s:{...fin,p0:point(n0.x,n0.y)},n0,n1:null});
   }
   const k0=pieces.findIndex(p=>p.n0),ordre=pieces.slice(k0).concat(pieces.slice(0,k0));
   let cur=null;
   for(const p of ordre){
    if(p.n0){cur={a:p.n0,segs:[]};}
    cur.segs.push(p.s);
    if(p.n1){cur.b=p.n1;if(!dansU(milieu(cur.segs[0])))runs.push(cur);cur=null;}
   }
  }
  /* les bords des réserves : la parité de D, tenue le long du bord */
  for(let jj=0;jj<polys.length;jj++){
   const {j,P}=polys[jj],seq=[];let nb=0;
   for(let k=0;k<P.edges.length;k++){
    seq.push({p:P.pts[k]});
    const l=surArete[jj][k].sort((x,y)=>x.u-y.u);
    /* deux contours du dessin peuvent partager un bord (le traceur en produit) : ils croisent la réserve au
       MÊME point, deux nœuds distincts, gardés dans l'ordre d'arrivée. Deux nœuds presque confondus mais
       distincts, eux, sont un cas limite. */
    for(let q=1;q<l.length;q++)if(l[q].u-l[q-1].u<1e-12&&Math.hypot(l[q].nd.x-l[q-1].nd.x,l[q].nd.y-l[q-1].nd.y)>1e-9)throw DEGENERE;
    for(const x of l){seq.push({p:x.nd,nd:x.nd});nb++;}
   }
   let par=pariteD(P.pts[0]);
   if(!nb){
    if(par&&!autreDedans(jj,P.pts[0])){utiles.add(j);const segs=P.pts.map((p,k)=>({type:'L',p0:p,p2:P.pts[(k+1)%P.pts.length]}));sortie.push({segs,touche:true});}
    else if(par)utiles.add(j);
    continue;
   }
   if(par)utiles.add(j);
   for(const x of seq){if(x.nd&&x.nd.D)par^=1;x.par=par;}
   if(par!==seq[0].par)throw DEGENERE;                       // un nombre impair de croisements : cas limite
   const k0=seq.findIndex(x=>x.nd),ordre=seq.slice(k0).concat(seq.slice(0,k0),[seq[k0]]);
   let cur=null;
   for(let q=0;q<ordre.length;q++){
    const x=ordre[q];
    if(cur&&cur.pts[cur.pts.length-1]!==x.p)cur.pts.push(x.p);
    if(x.nd&&q){cur.b=x.nd;const s0={type:'L',p0:cur.pts[0],p2:cur.pts[1]};
     if(cur.par&&!autreDedans(jj,milieu(s0)))runs.push({a:cur.a,b:cur.b,segs:cur.pts.slice(1).map((p,k)=>({type:'L',p0:cur.pts[k],p2:p})),reserve:true});cur=null;}
    if(x.nd&&q<ordre.length-1)cur={a:x.nd,pts:[x.p],par:x.par};
   }
  }
  /* l'enchaînement : chaque nœud a exactement deux morceaux */
  const inc=new Map();
  for(const r of runs)for(const nd of [r.a,r.b]){const l=inc.get(nd);if(l)l.push(r);else inc.set(nd,[r]);}
  for(const l of inc.values())if(l.length!==2)throw DEGENERE;
  const vu=new Set();
  for(const r0 of runs){
   if(vu.has(r0))continue;
   const boucle=[],depart=r0.a;let r=r0,de=r0.a;
   for(let garde=0;garde<=runs.length;garde++){
    vu.add(r);const sens=r.a===de;boucle.push(...(sens?r.segs:renverser(r.segs)));
    const vers=sens?r.b:r.a;if(vers===depart)break;
    const suite=inc.get(vers).find(x=>x!==r);if(!suite||vu.has(suite))throw DEGENERE;
    r=suite;de=vers;
   }
   sortie.push({segs:boucle,touche:true});
  }
  return sortie;
 }
 /* La découpe INCRÉMENTALE, contour par contour : un contour que n'approche aucune réserve donne le même tracé que
    sans réserve (le corps de la boucle de cropNu). On le garde, pour un dessin, un placement et une forme ; quand seul
    un texte bouge, seuls les contours qu'il approche sont recalculés. La parité du dessin le long des réserves se lit
    dans le repère d'ORIGINE du dessin : la pose n'est qu'une échelle positive et une translation, un rayon horizontal
    y reste horizontal, et les contours lointains ne sont jamais transformés. */
 let memo={cle:null,svg:null,groupes:[]};const boitesSource=new WeakMap();
 function boiteSource(c){let b=boitesSource.get(c);if(!b){b=boiteSegs(c);boitesSource.set(c,b);}return b;}
 function boiteGroupe(g){let b=boitesSource.get(g);if(!b){b=[Infinity,Infinity,-Infinity,-Infinity];for(const c of g){const q=boiteSource(c);b=[Math.min(b[0],q[0]),Math.min(b[1],q[1]),Math.max(b[2],q[2]),Math.max(b[3],q[3])];}boitesSource.set(g,b);}return b;}
 function pariteSource(q,group){let n=0;for(const c of group){const b=boiteSource(c);if(q.y<b[1]||q.y>b[3]||q.x>b[2])continue;for(const s of c)n+=croisementsRayon(s,q);}return n&1;}
 function decouperAvecReserves(parsed,transform,inverse,area,polys,o,state,cle){
  const groups=[],utiles=new Set();let paths=0,points=0,ilots=0,minX=Infinity,minY=Infinity,maxX=-Infinity,maxY=-Infinity;
  const n=v=>String(Math.round(v*1e4)/1e4),coord=p=>n(p.x)+' '+n(p.y);
  if(memo.cle!==cle)memo={cle,svg:memo.svg,groupes:[]};
  const boiteT=b=>{const a=transform(point(b[0],b[1])),c=transform(point(b[2],b[3]));return [Math.min(a.x,c.x),Math.min(a.y,c.y),Math.max(a.x,c.x),Math.max(a.y,c.y)];};
  const poser=c=>c.map(s=>({type:s.type,p0:transform(s.p0),...(s.p1?{p1:transform(s.p1)}:{}),p2:transform(s.p2)}));
  /* la face, contour par contour (mêmes filtres que cropNu) */
  const aLaFace=(segs,st)=>{
   let result=segs;for(const plane of area.planes){result=cut(result,plane,st);if(!result.length)return null;}
   let loX=Infinity,hiX=-Infinity,loY=Infinity,hiY=-Infinity;for(const s of result)for(const p of extrema(s)){loX=Math.min(loX,p.x);hiX=Math.max(hiX,p.x);loY=Math.min(loY,p.y);hiY=Math.max(hiY,p.y);}
   const aire=signedArea(result);
   if(hiX-loX<EPS||hiY-loY<EPS||Math.abs(aire)<1e-10)return null;
   return {result,box:[loX,loY,hiX,hiY],aire};
  };
  const ecrire=r=>{let d='M'+coord(r[0].p0);for(const s of r)d+=s.type+(s.type==='Q'?coord(s.p1)+' ':'')+coord(s.p2);return d+'Z';};
  for(let gi=0;gi<parsed.groups.length;gi++){
   const group=parsed.groups[gi],mg=memo.groupes[gi]||(memo.groupes[gi]={c:[]});
   const gb=boiteT(boiteGroupe(group)),ici=polys.filter(x=>chevauche(gb,x.P.box)),loin=[],proches=[];
   for(let ci=0;ci<group.length;ci++)(ici.length&&ici.some(x=>chevauche(boiteT(boiteSource(group[ci])),x.P.box))?proches:loin).push(ci);
   const items=[];
   for(const ci of loin){
    let f=mg.c[ci];
    if(!f){const st={clipped:false},r=aLaFace(poser(group[ci]),st);f=mg.c[ci]=r?{d:ecrire(r.result),points:r.result.length,box:r.box,p0:r.result[0].p0,clipped:st.clipped}:{d:'',clipped:st.clipped};}
    if(f.clipped)state.clipped=true;if(f.d)items.push(f);
   }
   if(proches.length){
    const liste=soustraire(proches.map(ci=>poser(group[ci])),ici,utiles,P=>pariteSource(inverse(P),group));
    for(const it of liste){const r=aLaFace(it.segs,state);if(r)items.push({...r,touche:it.touche,points:r.result.length,p0:r.result[0].p0});}
   }
   /* les poussières : un îlot NÉ de la coupe (il porte un bout de réserve) plus petit que `ilot` mm² est retiré, sauf s'il
      contient un autre contour (on ne remplirait jamais un trou). Retirer de l'encre ne rapproche jamais rien d'une réserve. */
   const retires=new Set();
   if(o.ilot>0)for(const g of items){
    if(!g.touche||Math.abs(g.aire)>=o.ilot)continue;
    const loge=items.some(h=>h!==g&&h.box[0]>=g.box[0]&&h.box[2]<=g.box[2]&&h.box[1]>=g.box[1]&&h.box[3]<=g.box[3]&&parite(h.p0,[g.result],[g.box]));
    if(!loge){retires.add(g);ilots++;}
   }
   let d='';
   for(const g of items){
    if(retires.has(g))continue;
    paths++;points+=g.points;minX=Math.min(minX,g.box[0]);minY=Math.min(minY,g.box[1]);maxX=Math.max(maxX,g.box[2]);maxY=Math.max(maxY,g.box[3]);
    d+=g.d||ecrire(g.result);
   }
   if(d)groups.push('<path d="'+d+'"/>');
  }
  return {groups,paths,points,ilots,utiles,bounds:paths?{minX,minY,maxX,maxY}:null};
 }
 function cropReserve(svg,element,shape,options,boites){
  const t0=(typeof performance==='object'?performance:Date).now();
  const parsed=parse(svg),area=surface(shape,options),{width:W,height:H}=area,view=parsed.view,o={...RESERVE,...(options.reserve||{})};
  const size=Number(element.size),x=Number(element.x),y=Number(element.y);
  if(![size,x,y].every(Number.isFinite)||size<=0)throw Error('Position du dessin invalide.');
  const scale=size*1.2/Math.max(view[2],view[3]),cx=view[0]+view[2]/2,cy=view[1]+view[3]/2;
  const transform=p=>point((p.x-cx)*scale+x*W,(p.y-cy)*scale+y*H),inverse=p=>point((p.x-x*W)/scale+cx,(p.y-y*H)/scale+cy),cle=[shape,area.margin,x,y,size].join('|');
  if(memo.svg!==svg)memo={cle:null,svg,groupes:[]};
  /* On recommence avec les seules réserves utiles, jusqu'à ce qu'elles le soient toutes : la marque et la
     redécoupe depuis la marque donnent alors le même tracé. */
  let liste=boites,res=null,state=null,essais=0;
  for(let tour=0;tour<4&&liste.length;tour++){
   for(let essai=0;;essai++){
    /* [réserve-courbe, 02/11] chaque PIÈCE a son écart de face (compteur g, sur toutes les réserves : deux mots qui débordent du
       même bord n'ont jamais de bords confondus) ; `j` reste l'indice de la réserve (utiles). Des boîtes seules : g = j, d'avant. */
    const polys=[];let g=0;liste.forEach((b,j)=>{const d=essai?essai*1e-5*(j+1):0;let pcs=piecesReserve(b,o,d);if(b.forme&&essai)pcs=pcs.map((p,q)=>homothetie(p,essai*1e-6*(q+1)));
     for(const p of pcs){const pts=couperPoly(p,area.planes,(g+1)*1e-5);g++;if(pts)polys.push({j,P:preparerPolygone(pts)});}});
    state={clipped:false};
    try{res=decouperAvecReserves(parsed,transform,inverse,area,polys,o,state,cle);essais+=essai;break;}
    catch(e){if(e!==DEGENERE)throw e;if(essai>=6){res=null;break;}}
   }
   if(!res||res.utiles.size===liste.length)break;
   liste=liste.filter((b,j)=>res.utiles.has(j));res=null;
  }
  /* Rien d'utile, échec, ou plus aucun trait : la découpe d'origine (jamais une gravure vide). */
  if(!res||!liste.length||!res.paths){const nu=cropNu(svg,element,shape,options);return {...nu,reserves:[],ilots:0,essais,echec:!res&&liste.length>0,ms:(typeof performance==='object'?performance:Date).now()-t0};}
  const output='<svg xmlns="http://www.w3.org/2000/svg" width="'+W+'mm" height="'+H+'mm" viewBox="0 0 '+W+' '+H+'" fill="#4a2616" fill-rule="evenodd" stroke="none">'+res.groups.join('')+'</svg>';
  return {svg:output,viewBox:[0,0,W,H],placement:{x:.5,y:.5,size:Math.max(W,H)/1.2},physical:{width:W,height:H},polygon:area.polygon,paths:res.paths,points:res.points,bounds:res.bounds,clipped:state.clipped,
   reserves:liste,ilots:res.ilots,essais,echec:false,ms:(typeof performance==='object'?performance:Date).now()-t0};
 }
 /* Le dessin SANS réserve, pour le même placement : le SVG de cropNu, au caractère près, mais tiré de la mémoire contour par
    contour (les contours que la dernière découpe avec réserves a déjà posés à la face ne sont pas refaits ; les autres y entrent).
    L'aperçu du module photo en a besoin : pendant le glisser d'un texte, il peint ce dessin, troué aux textes de l'image. */
 function sansReserve(svg,element,shape,options={}){
  const parsed=parse(svg),area=surface(shape,options),{width:W,height:H}=area,view=parsed.view;
  const size=Number(element.size),x=Number(element.x),y=Number(element.y);
  if(![size,x,y].every(Number.isFinite)||size<=0)throw Error('Position du dessin invalide.');
  const scale=size*1.2/Math.max(view[2],view[3]),cx=view[0]+view[2]/2,cy=view[1]+view[3]/2;
  const transform=p=>point((p.x-cx)*scale+x*W,(p.y-cy)*scale+y*H),cle=[shape,area.margin,x,y,size].join('|');
  const n=v=>String(Math.round(v*1e4)/1e4),coord=p=>n(p.x)+' '+n(p.y),groups=[];let paths=0;
  if(memo.svg!==svg)memo={cle:null,svg,groupes:[]};
  if(memo.cle!==cle)memo={cle,svg,groupes:[]};
  for(let gi=0;gi<parsed.groups.length;gi++){
   const group=parsed.groups[gi],mg=memo.groupes[gi]||(memo.groupes[gi]={c:[]});let d='';
   for(let ci=0;ci<group.length;ci++){
    let f=mg.c[ci];
    if(!f){   /* le corps de la boucle de cropNu, gardé comme le fait la découpe avec réserves pour ses contours lointains */
     const st={clipped:false};let result=group[ci].map(q=>({type:q.type,p0:transform(q.p0),...(q.p1?{p1:transform(q.p1)}:{}),p2:transform(q.p2)}));
     for(const plane of area.planes){result=cut(result,plane,st);if(!result.length)break;}
     let loX=Infinity,hiX=-Infinity,loY=Infinity,hiY=-Infinity;for(const q of result)for(const e of extrema(q)){loX=Math.min(loX,e.x);hiX=Math.max(hiX,e.x);loY=Math.min(loY,e.y);hiY=Math.max(hiY,e.y);}
     if(!result.length||hiX-loX<EPS||hiY-loY<EPS||Math.abs(signedArea(result))<1e-10)f={d:'',clipped:st.clipped};
     else{let t='M'+coord(result[0].p0);for(const q of result)t+=q.type+(q.type==='Q'?coord(q.p1)+' ':'')+coord(q.p2);f={d:t+'Z',points:result.length,box:[loX,loY,hiX,hiY],p0:result[0].p0,clipped:st.clipped};}
     mg.c[ci]=f;
    }
    if(f.d){d+=f.d;paths++;}
   }
   if(d)groups.push('<path d="'+d+'"/>');
  }
  return {svg:'<svg xmlns="http://www.w3.org/2000/svg" width="'+W+'mm" height="'+H+'mm" viewBox="0 0 '+W+' '+H+'" fill="#4a2616" fill-rule="evenodd" stroke="none">'+groups.join('')+'</svg>',paths};
 }
 function crop(svg,element,shape,options={}){
  const boites=boitesValides(options.reserves);
  return boites.length?cropReserve(svg,element,shape,options,boites):cropNu(svg,element,shape,options);
 }
 const api={crop,surface,polygoneReserve,piecesReserve,boitesValides,sansReserve,RESERVE,VERSIONS};if(typeof module==='object'&&module.exports)module.exports=api;else root.PhotoCrop=api;
})(typeof window==='object'?window:this);
